import { IPageDTO } from "@/interfaces/IPageDTO";
import { atom } from "recoil";

const GlobalSearchResultAtom = atom<IPageDTO[]>({
    default: [],
    key: 'globalSearchResultAtomKey'
})

export default GlobalSearchResultAtom;